import { Box, Typography } from '@mui/material';
import {
  mobileBlockerStyles,
  mobileFooterStyles,
  mobileLogoStyles,
  p1Styles,
  p2Styles,
} from './MobileBlockerProps';

const MobileBlocker = () => {
  return (
    <Box data-testid="mobile-blocker" sx={mobileBlockerStyles}>
      <Box sx={mobileLogoStyles}>
        <a className="logo" href="/">
          <img
            src={`${import.meta.env.VITE_DO_SPACE_URL}/assets/taskit-logo.png`}
            alt="logo"
          />
        </a>
      </Box>
      <Typography sx={p1Styles}>
        Taskit is not <br /> currently available <br /> on mobile devices.
      </Typography>
      <Typography sx={p2Styles}>
        Please visit us on a desktop for full access.
      </Typography>
      <Typography sx={mobileFooterStyles}>
        © {new Date().getFullYear()} TaskIt. All Rights Reserved. <br /> Made by{' '}
        <a target="_blank" rel="noreferrer" href="https://forwardslashny.com/">
          Forwardslash
        </a>
        .
      </Typography>
    </Box>
  );
};

export default MobileBlocker;
